// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/icing.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/icing/clear-vs-rime-ice.js';
import g1 from '../lessons/meteorology/icing/icing.js';

mount([g0, g1]);
